export interface ClientWithEntitiesDto {
  ClientId: string;
  ClientName: string;
  OnBoardingStatus: string;
  Entities: EntityDto[];
  ClientTaxPeriods: ClientTaxPeriodDto[];
}

export interface EntityDto {
  EntityId: string;
  EntityName: string;
  VertexCompanyCode: string;
  IsActive: boolean;
  Roles: RoleDto[];
  CreatedByUserId: string;
  CreatedDate: Date;
  MileStones: MileStoneDto[];
}

export interface RoleDto {
  RoleId: number;
  RoleName: string;
}

export interface MileStoneDto {
  Id: number;
  Name: string;
  Status: string;
}

export interface ClientTaxPeriodDto {
  ClientTaxPeriodId: number;
  TaxPeriodId: number;
  Month: number;
  Year: number;
  WorkpaperLocation: string;
  PreparedBy: string;
  ReviewedBy: string;
  IsCurrent: boolean;
}
